import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

interface ScrollTriggerOptions {
  trigger?: string;
  start?: string;
  end?: string;
  scrub?: boolean | number;
  markers?: boolean;
  once?: boolean;
}

export function useGsapScrollTrigger(
  animation: (tl: gsap.core.Timeline, el: HTMLElement) => void,
  options: ScrollTriggerOptions = {},
) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (prefersReducedMotion) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: options.start ?? "top 80%",
        end: options.end ?? "bottom 20%",
        scrub: options.scrub ?? false,
        markers: options.markers ?? false,
        toggleActions: options.once ? "play none none none" : "play none none reverse",
      },
    });

    animation(tl, el);

    return () => {
      tl.kill();
      ScrollTrigger.getAll().forEach((st) => {
        if (st.trigger === el) st.kill();
      });
    };
  }, []);

  return ref;
}
